import { RootState } from '../../../../../../../../init-store';
import { selectParticipantRenderState } from '../../../../../../../shared/features/room-agent/dtmf/participant-list/selectors';
import { i18n } from '../../../../../../../shared/helpers/i18n';
import { FONT_FAMILY, TEXT_COLOR_SECONDARY } from '../constants';
import { Area, Drawer } from '../types';
import { SCALE } from './constants';

const PAGE_STATE_FONT_SIZE = Math.round(18 * SCALE);
const PAGE_STATE_FONT = `${PAGE_STATE_FONT_SIZE}px ${FONT_FAMILY}`;

export const PAGE_STATE_HEIGHT = Math.round(18 * SCALE);

export class PageStateDrawer implements Drawer {
    private area: Area;

    constructor(area: Area) {
        this.area = area;
    }

    public draw(ctx: CanvasRenderingContext2D, state: RootState) {
        const { currentPageIdx, totalPages } = selectParticipantRenderState(state);

        if (totalPages < 2) {
            return;
        }

        const text = i18n('dtmf', 'participant-list.page-state', { currentPage: currentPageIdx + 1, totalPages });

        ctx.textBaseline = 'top';
        ctx.font = PAGE_STATE_FONT;
        ctx.fillStyle = TEXT_COLOR_SECONDARY;

        const textMetrics = ctx.measureText(text);
        const x = Math.round(this.area.x + (this.area.width - textMetrics.width) / 2);
        const y = this.area.y;

        ctx.fillText(text, x, y);
    }
}
